"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDropDownGtmObject = void 0;

var getDropDownGtmObject = function getDropDownGtmObject(label, category) {
  if (label && category) {
    return {
      event: 'trackEventNoEcommerce',
      'eventDetails.category': category,
      'eventDetails.action': "error",
      'eventDetails.label': "noresults|".concat(label)
    };
  }

  return null;
};

exports.getDropDownGtmObject = getDropDownGtmObject;